(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ua-article"]) return;
  try {
    
(function () {
  function step(track) {
    var item = track.querySelector('.ua-card');
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
  }
  // Dots under the row, one per card the row can start on, like the product carousels (Ben, 5 Oct).
  function setup(wrap) {
    if (wrap.dataset.uaReady) return;
    wrap.dataset.uaReady = '1';
    var track = wrap.querySelector('.ua-carousel');
    var box = wrap.querySelector('.ua-carousel__dots');
    var prev = wrap.querySelector('[data-ua-dir="-1"]');
    var next = wrap.querySelector('[data-ua-dir="1"]');
    var dots = [];
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var count = max > 2 ? Math.round(max / step(track)) + 1 : 0;
      if (box && dots.length !== count) {
        box.innerHTML = '';
        dots = [];
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ua-carousel__dot';
          dot.dataset.uaGo = String(i);
          dot.setAttribute('aria-label', 'Show from item ' + (i + 1) + ' of ' + count);
          box.appendChild(dot);
          dots.push(dot);
        }
      }
      wrap.classList.toggle('is-static', !count);
      if (!count) return;
      var active = track.scrollLeft >= max - 2 ? count - 1 : Math.round(track.scrollLeft / step(track));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        if (i === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }
  function init() {
    document.querySelectorAll('.ua-carousel-wrap').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.ua-carousel__dot');
    var button = event.target.closest('.ua-carousel__btn');
    if (!dot && !button) return;
    var track = (dot || button).closest('.ua-carousel-wrap').querySelector('.ua-carousel');
    if (!track) return;
    if (dot) {
      track.scrollTo({ left: Math.min(Number(dot.dataset.uaGo) * step(track), track.scrollWidth - track.clientWidth), behavior: 'smooth' });
      return;
    }
    var visible = Math.max(1, Math.floor((track.clientWidth + 1) / step(track)));
    track.scrollBy({ left: Number(button.dataset.uaDir) * visible * step(track), behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
